export const isUndefined = value => typeof value === 'undefined'
export const not = predicate => (...args) => !predicate(...args)
export const isDefined = not(isUndefined)
export const and = (...predicates) => (...args) => predicates.every(predicate => predicate(...args))
export const or = (...predicates) => (...args) => predicates.some(predicate => predicate(...args))

export const parseIntOrUndef = value => {
  const int = parseInt(value)
  return isNaN(int) || `${int}` !== `${value}` ? undefined : int
}

export const isObject = value => value === Object(value)
export const isFunction = value => typeof value === 'function'
export const isNone = value => value == null || value === ''
